
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 45 45","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M35.336 7.572V6.23c0-.679-.554-1.23-1.232-1.23h-1.02c-.68 0-1.233.553-1.233 1.23v1.315l-7.943.002V6.232c0-.679-.554-1.23-1.232-1.23h-1.02c-.68 0-1.232.553-1.232 1.23v1.315h-7.942V6.232c0-.679-.554-1.23-1.232-1.23h-1.02c-.68 0-1.232.553-1.232 1.23v1.366A3.564 3.564 0 006 11.125v25.297A3.584 3.584 0 009.583 40h25.334a3.584 3.584 0 003.583-3.578l-.004-25.3a3.583 3.583 0 00-3.16-3.55zm-2.549-1.34c0-.164.134-.296.297-.296h1.02c.164 0 .296.134.296.296v3.564a.296.296 0 01-.296.295h-1.02a.296.296 0 01-.297-.295V6.232zm-11.427 0c0-.164.133-.296.296-.296h1.02c.165 0 .296.134.296.296v3.564a.296.296 0 01-.296.295h-1.02a.296.296 0 01-.296-.295V6.232zm-11.428 0c0-.164.134-.296.297-.296h1.02c.164 0 .296.134.296.296v3.564a.296.296 0 01-.296.295h-1.02a.296.296 0 01-.297-.295V6.232zm-.936 2.315v1.247c0 .679.554 1.23 1.233 1.23h1.02c.68 0 1.232-.553 1.232-1.23V8.479h7.943v1.315c0 .679.554 1.23 1.232 1.23h1.02c.68 0 1.232-.553 1.232-1.23V8.479h7.944v1.315c0 .679.554 1.23 1.232 1.23h1.02c.68 0 1.232-.553 1.232-1.23V8.516a2.647 2.647 0 012.227 2.607v4.547l-30.628.002v-4.548c0-1.263.874-2.31 2.062-2.577zm25.92 30.517H9.58a2.648 2.648 0 01-2.647-2.644l.002-19.813h30.626V36.42a2.65 2.65 0 01-2.647 2.644z","fill":"#000","fill-rule":"nonzero"}}),_c('g',{attrs:{"stroke":"#BF9C5F","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}},[_c('path',{attrs:{"d":"M14.825 20.825l14.85 14.85M29.675 20.825l-14.85 14.85"}})])])])
          )
        }
      }
    